/*
* @Author: nizhanjun
* @Date:   2018-08-14 18:47:38
* @Last Modified by:   nizhanjun
* @Last Modified time: 2018-08-14 18:48:43
*/
import Avatar from './avatar.vue'
export default Avatar



// WEBPACK FOOTER //
// ./src/components/base/avatar/index.js